<template>
  <div v-bind:class="{ 'form-group': true, 'has-error': this.m_error !== null }">
    <label>{{ field.label }}</label>
    <select class="form-control" v-model="m_fieldAnswer.value" :disabled="disabledAttribute">
      <option selected="selected" :value="null"></option>
      <option v-for="year in getYearsRange()">{{ year }}</option>
    </select>
  </div>
</template>

<script>
  export default {
    props: ['field', 'fieldAnswer', 'isDisabled'],
    name: 'YearField',
    data () {
      return {
        m_fieldAnswer: {
          fieldUuid: this.field.uuid,
          value: parseInt(this.fieldAnswer.value)
        },
        m_error: null,
        m_rowIndex: this.fieldAnswer.rowIndex
      }
    },
    computed: {
      disabledAttribute () {
        return this.field.disabled === true || this.isDisabled === true
      }
    },
    watch: {
      'm_fieldAnswer.value' () {
        this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer)
      }
    },
    methods: {
      getYearsRange () {
        let currentYear = new Date().getFullYear()
        let startYear = 1985
        let years = []
        while (currentYear >= startYear) {
          years.push(currentYear--)
        }

        return years
      },
      isValid () {
        if (this.field.required && !this.m_fieldAnswer.value) {
          this.m_error = true
          return false
        }
        this.m_error = null
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// YearField.vue?e7ea415a